"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Button = _interopRequireDefault(require("./Button"));

var _styling = require("../../toolkit/styling");

var icons = _interopRequireWildcard(require("../../toolkit/icons"));

var _device = require("../../toolkit/device");

var _localization = require("../../toolkit/localization");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BackButton = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(BackButton, _Component);

  var _super = _createSuper(BackButton);

  function BackButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, BackButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;

    _this.onClickDefault = function () {
      window.history.back();
    };

    return _this;
  }

  (0, _createClass2["default"])(BackButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href;

      var dimenStore = _device.DeviceStore.instance();

      var padding = "7px ".concat(dimenStore.isSmallScreen ? 25 : 60, "px");

      var _LocalizationStore = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore.i18n;

      return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
        padding: padding,
        onClick: href == null ? this.onClickDefault : undefined
      }, this.props), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root)
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: (0, _styling.css)(this.styles.icon),
        src: icons.chevronRight,
        alt: "back arrow"
      }), children ? children : i18n("Back")));
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        icon: {
          height: 13,
          marginRight: 5,
          transform: "rotate(180deg)"
        }
      });
    }
  }]);
  return BackButton;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = _Button["default"].propDoc, _class3.demoProps = {
  onClick: function onClick() {}
}, _class3.demoRender = "\n<BackButton onClick={() => {}} />\n", _class3.discussion = "\n    This component wraps [`Button`](/lego/component/Button)\n  ", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = BackButton;
exports["default"] = _default;